import classnames from 'classnames'

import GrowthIndicator from '~/components/atoms/GrowthIndicator/GrowthIndicator'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { Growth } from '~/enums/growth'

import styles from './GrowthStatus.module.css'

export type growthType = {
  value: number
  growth: Growth
}

export interface GrowthStatusProps {
  testID?: string
  growth?: number
  size?: 'small' | 'medium' | 'mediumLarge'
  largeText?: boolean
  title?: string
  monochrome?: boolean
  hideGraph?: boolean
  graphGrey?: boolean
  showInfoIcon?: boolean
  showEmptyText?: boolean
  smallFont?: boolean
  underlined?: boolean
}

export default function GrowthStatus({
  testID,
  growth,
  size = 'small',
  largeText = false,
  title,
  monochrome = false,
  hideGraph = false,
  graphGrey = false,
  showInfoIcon = false,
  showEmptyText = false,
  smallFont = false,
  underlined = false,
}: GrowthStatusProps) {
  let indicator = Growth.static
  if (growth && growth > 0) indicator = Growth.increase
  if (growth && growth < 0) indicator = Growth.decrease

  let growthIconColor = '#6844d6'
  if (monochrome) growthIconColor = '#222'
  if (graphGrey) growthIconColor = '#666666'

  return (
    <div className={styles.base} data-testid={testID}>
      <div
        className={classnames(
          styles.growthStatus,
          styles[size],
          largeText && styles.largeTextWrap
        )}
      >
        {showInfoIcon ? (
          <Icon type="InfoIcon" />
        ) : (
          <GrowthIndicator
            type={indicator}
            size={size}
            monochrome={monochrome}
          />
        )}
        <Text
          className={classnames(
            styles.text,
            largeText ? styles.textLarge : styles.smallText,
            smallFont && styles.smallFont,
            {
              [styles.underlined]: underlined,
            }
          )}
          size={largeText ? TextSizes.bodyLrg : TextSizes.bodySml}
        >
          {showEmptyText ? (
            <>N/A{title && <span className={styles.title}> {title}</span>}</>
          ) : (
            <>
              {growth}%{title && <span className={styles.title}> {title}</span>}
            </>
          )}
        </Text>
        {!hideGraph && (
          <Icon type="Growth" width={16} height={16} fill={growthIconColor} />
        )}
      </div>
    </div>
  )
}
